import DropdownMenu, { DropdownAction } from 'components/DropdownMenu';

type Props = {
  title: string;
  loading: boolean;
  actions: Array<DropdownAction>;
};

const ExportDropdownMenu: React.FC<Props> = ({ title, loading, actions }) => {
  return (
    <DropdownMenu
      title={title}
      loading={loading}
      actions={actions}
      menuId="export-menu"
      size="medium"
    />
  );
};

export default ExportDropdownMenu;
